import { AsyncCreatableSelect } from '../../components/select-form/select-form';
import { QBOTaxCode } from '../../clients/quipli-service/qbo/qbo';
import { components } from 'react-select';
import { Typography } from '../../components/typography/typography';
import Icon from '../../components/icons/icon';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { useQboApi } from '../../clients/quipli-service/qbo/qbo-api-v1';

export const QboTaxCodeSelect = ({
  taxCodeId,
  setTaxCodeId,
}: {
  taxCodeId?: string;
  setTaxCodeId: (id?: string) => void;
}) => {
  const [selectedTaxCode, setSelectedTaxCode] = useState<QBOTaxCode | undefined>();
  const { listTaxCodes } = useQboApi();

  async function fetchSelectedTaxCode(taxCodeId: string) {
    if (taxCodeId === 'NON' || taxCodeId === 'TAX') {
      setSelectedTaxCode({ Id: taxCodeId, Name: taxCodeId });
    } else {
      const result = await listTaxCodes({ ids: [taxCodeId] });
      if (result.length) {
        setSelectedTaxCode(result[0]);
      }
    }
  }

  useEffect(() => {
    if (taxCodeId && taxCodeId !== selectedTaxCode?.Id) {
      fetchSelectedTaxCode(taxCodeId);
    }
  }, [taxCodeId, selectedTaxCode]);

  const searchQbo = useCallback(
    debounce((callback, keyword?: string) => {
      listTaxCodes({
        offset: 0,
        pageSize: 200,
        name: keyword,
      }).then((res) => callback(res));
    }, 300),
    [],
  );

  return (
    <AsyncCreatableSelect<QBOTaxCode>
      cacheOptions
      defaultOptions
      getOptionLabel={(op) => op.Name}
      getOptionValue={(op) => `${op.Id}`}
      value={selectedTaxCode}
      noOptionsMessage={() => 'No QuickBooks tax codes found'}
      onClickCreatableOption={() => setTaxCodeId(undefined)}
      menuShouldBlockScroll
      menuPosition="fixed"
      menuPortalTarget={document.body}
      loadOptions={(keyword, callback) => searchQbo(callback, keyword)}
      onChange={(selected) => setTaxCodeId(selected?.Id)}
      components={{
        Placeholder: (props) => (
          <components.Placeholder {...props}>
            <Typography type="text-sm">Search QBO Tax Codes</Typography>
          </components.Placeholder>
        ),
        ValueContainer: (props) => (
          <div className="flex items-center gap-[6px] pl-[10px]">
            <Icon icon="Search" size="medium" stroke="var(--grey-500)" />
            <components.ValueContainer {...props} />
          </div>
        ),
        Option: (props) => {
          //@ts-expect-error __isNew__
          const isCreateOption = props.data.__isNew__ === true;
          if (isCreateOption) return <> </>;
          return (
            <components.Option {...props}>
              <div className={classNames('flex items-center gap-[6px] justify-between')}>
                {!isCreateOption ? (
                  <>
                    <div className="flex flex-col gap-[4px]">
                      <Typography type="text-md" weight="medium" className="text-grey-900">
                        {props.children}
                      </Typography>
                      <div>
                        {props.data.Name && (
                          <Typography type="text-sm" className="text-grey-500">
                            {props.data.Name}
                          </Typography>
                        )}
                      </div>
                    </div>
                    {props.isSelected && <Icon icon="Check" stroke="var(--quipli-black-800)" />}
                  </>
                ) : (
                  <>
                    <Typography type="text-md" weight="medium" className="text-grey-900">
                      None
                    </Typography>
                  </>
                )}
              </div>
            </components.Option>
          );
        },
      }}
    />
  );
};
